import React from 'react';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";

import { AppState } from '../../appredux'

import CONFIG from '../../cfg/config';

import logoVirtual from './../logo_virtual.png';

import Contact from "./Contact"
import { Info } from '../../api';
import theme from '../../themes';

//PM 2021-11-25
//wstrzykniecie tylko uzywnaych pol z magazynu danych
type KontaktProps = {
  contact: Info
}

class Kontakt extends React.Component<KontaktProps, any> {
  logoUrl: string = `${CONFIG.apiURL}/hotel/image/${CONFIG.hotelID}/logo.png`
  //PM 2021-11-25
  //wstrzykniecie tylko uzywnaych pol z magazynu danych
  render() {

    const data = {
      title: "Zamówienia",
      email: this.props.contact.kontaktEmail,
      phone: this.props.contact.kontaktTelefon,
      gps: this.props.contact.kontaktGps,
      address: this.props.contact.kontaktAdres
    }

    const data1 = {
      title: "Internet",
      email: "pytania@virtualsc.com.pl",
      phone: "606 257 683",
      gps: "50.0443566N 21.9925000E",
      address: "ul. Kamińskiego 8/4, 35-211 Rzeszów"
    }

    return (
      <>
        <Contact data={data} logo={this.logoUrl} titleSize="14px" fontSize="13px" iconSize="16px" color="#5F9EA0" />
        <Contact data={data1} logo={logoVirtual} color={theme.palette.primary.main}/>
      </>
      // <>
      //   <Grid item xs={12} md={6} className={classes.leftGrid}>
      //     <Typography variant="h6" component="h2" color="primary" style={{ paddingBottom: "15px", fontWeight: "bold" }}>
      //       w sprawach zamówień:
      //       </Typography>
      //     <hr />
      //     <div className={classes.tableContainer}>
      //       <Table>
      //         <TableBody>
      //           <TableRow >
      //             <TableCell align="left" style={{ width: "90px" }}
      //               className={classes.cell}>
      //               <Typography variant="h6" component="h2">
      //                 <MailIcon className={`${classes.icon} `} style={{ marginBottom: "-4px" }} />
      //                 <span className={classes.title} >
      //                   email:
      //             </span>
      //               </Typography>
      //             </TableCell>
      //             <TableCell align="right" className={classes.cell}>
      //               <Typography variant="h6" component="h2" color='primary' className={classes.tableText}>
      //                 <a href={`mailto:${this.props.page.contact.kontakt_e_mail}`} className={classes.email}>{this.props.page.contact.kontakt_e_mail}</a>
      //               </Typography>
      //             </TableCell>
      //           </TableRow>
      //           <TableRow >
      //             <TableCell align="left" style={{ width: "100px" }}
      //               className={classes.cell}>
      //               <Typography variant="h6" component="h2" >
      //                 <CallIcon className={`${classes.icon} `} style={{ marginBottom: "-4px" }} />
      //                 <span className={classes.title} >
      //                   telefon:
      //             </span>
      //               </Typography>
      //             </TableCell>
      //             <TableCell align="right" className={classes.cell}>
      //               <Typography variant="h6" component="h2" color='primary' className={classes.tableText}>
      //                 {this.props.page.contact.kontakt_fax}
      //               </Typography>
      //             </TableCell>
      //           </TableRow>
      //           <TableRow >
      //             <TableCell align="left" style={{ width: "90px" }}
      //               className={classes.cell}>
      //               <Typography variant="h6" component="h2" >
      //                 <GpsIcon className={`${classes.icon} `} style={{ marginBottom: "-4px" }} />
      //                 <span className={classes.title} >
      //                   gps:
      //             </span>
      //               </Typography>
      //             </TableCell>
      //             <TableCell align="right" className={classes.cell}  >
      //               <Typography variant="h6" component="h2" color='primary' className={classes.tableText}>
      //                 {this.props.page.contact.kontakt_gps}
      //               </Typography>
      //             </TableCell>
      //           </TableRow>
      //           <TableRow >
      //             <TableCell align="left" style={{ width: "90px" }}
      //               className={classes.cell}>
      //               <Typography variant="h6" component="h2" >
      //                 <HomeIcon className={`${classes.icon} `} style={{ marginBottom: "-4px" }} />
      //                 <span className={classes.title} >
      //                   adres:
      //             </span>
      //               </Typography>
      //             </TableCell>
      //             <TableCell align="right" className={classes.cell}>
      //               <Typography variant="h6" component="h2" color='primary' className={classes.tableText}>
      //                 {this.props.page.contact.kontakt_adres}
      //               </Typography>
      //             </TableCell>
      //           </TableRow>
      //         </TableBody>
      //       </Table>
      //     </div>
      //     <Typography variant="h6" component="h2" color="primary">
      //       <p></p>
      //     </Typography>
      //     <Typography
      //       variant="h6" component="h2" color="primary"
      //       dangerouslySetInnerHTML={{ __html: this.props.page.kontakt[0].info }}
      //     />
      //     <div className={classes.pictureContainer}>
      //       <ResponsiveImgMaterialUi style={{ margin: "auto", display: "block", position: "relative", top: "50%", transform: "translateY(-50%)", width: "40%" }}
      //         xs={this.logoUrl}
      //         md={this.logoUrl}
      //         lg={this.logoUrl}
      //       />
      //     </div>
      //   </Grid>
      //   <Grid item xs={12} md={6} >

      //     <Typography variant="h6" component="h2" color="primary" style={{ paddingBottom: "15px", fontWeight: "bold" }}>
      //       w sprawach internetowych:
      //       </Typography>
      //     <hr />
      //     <div className={classes.tableContainer}>
      //       <Table >
      //         <TableBody>
      //           <TableRow >
      //             <TableCell align="left" style={{ width: "90px" }}
      //               className={classes.cell}>
      //               <Typography variant="h6" component="h2">
      //                 <MailIcon className={`${classes.icon} `} style={{ marginBottom: "-4px" }} />
      //                 <span className={classes.title} >
      //                   email:
      //             </span>
      //               </Typography>
      //             </TableCell>
      //             <TableCell align="right" className={classes.cell}>
      //               <Typography variant="h6" component="h2" color='primary' className={classes.tableText}>
      //                 <a href="mailto:pytania@virtualsc.com.pl" className={classes.email}>pytania@virtualsc.com.pl</a>
      //               </Typography>
      //             </TableCell>
      //           </TableRow>
      //           <TableRow>
      //             <TableCell align="left" style={{ width: "100px" }}
      //               className={classes.cell}>
      //               <Typography variant="h6" component="h2" >
      //                 <CallIcon className={`${classes.icon} `} style={{ marginBottom: "-4px" }} />
      //                 <span className={classes.title} >
      //                   telefon:
      //             </span>
      //               </Typography>
      //             </TableCell>
      //             <TableCell align="right" className={classes.cell}>
      //               <Typography variant="h6" component="h2" color='primary' className={classes.tableText}>
      //                 606 257 683
      //             </Typography>
      //             </TableCell>
      //           </TableRow>
      //           <TableRow >
      //             <TableCell align="left" style={{ width: "90px" }}
      //               className={classes.cell}>
      //               <Typography variant="h6" component="h2" >
      //                 <GpsIcon className={`${classes.icon} `} style={{ marginBottom: "-4px" }} />
      //                 <span className={classes.title} >
      //                   gps:
      //             </span>
      //               </Typography>
      //             </TableCell>
      //             <TableCell align="right" className={classes.cell}>
      //               <Typography variant="h6" component="h2" color='primary' className={classes.tableText}>
      //                 50.0443566N 21.9925000E
      //             </Typography>
      //             </TableCell>
      //           </TableRow>
      //           <TableRow >
      //             <TableCell align="left" style={{ width: "90px" }}
      //               className={classes.cell}>
      //               <Typography variant="h6" component="h2" >
      //                 <HomeIcon className={`${classes.icon} `} style={{ marginBottom: "-4px" }} />
      //                 <span className={classes.title} >
      //                   adres:
      //             </span>
      //               </Typography>
      //             </TableCell>
      //             <TableCell align="right" className={classes.cell}>
      //               <Typography variant="h6" component="h2" color='primary' className={classes.tableText}>
      //                 ul. Kamińskiego 8/4, 35-211 Rzeszów
      //             </Typography>
      //             </TableCell>
      //           </TableRow>
      //         </TableBody>
      //       </Table>
      //     </div>


      //     <div className={classes.pictureContainer}>
      //       <ResponsiveImgMaterialUi style={{ margin: "auto", display: "block", position: "relative", top: "50%", transform: "translateY(-50%)" }}
      //         xs={logoVirtual}
      //         md={logoVirtual}
      //         lg={logoVirtual}
      //       />
      //     </div>
      //   </Grid>
      // </>
    )
  }
}

const styles = (theme: Theme) => ({
  email: {
    color: "inherit",
    "&:hover": {
      textDecoration: "underline"
    }
  },
  title: {
    marginLeft: "1em",
    marginRight: "1em",
    fontSize: "13px"
  },
  icon: {
    backgroundColor: theme.palette.background.default
  },
  text: {
    color: theme.palette.text.primary
  },
  cell: {
    padding: "7px 5px 7px 5px",
    borderBottom: "1px solid rgba(224, 224, 224, 1)",
    color: "#555"
  },
  tableText: {
    fontSize: "13px"
  },
  pictureContainer: {
    height: "150px",
    position: "relative" as "relative"
  },
  tableContainer: {
    paddingLeft: "10px",
    paddingRight: "10px"
  },
  leftGrid: {
    paddingRight: "30px"
  },
  "@media screen and (max-width: 960px)": {
    leftGrid: {
      paddingRight: "0px"
    },
  },
});

const mapStateToProps = (state: AppState) => ({
  contact: state.pageState.contact
});

export default connect(mapStateToProps)(withStyles(styles)(Kontakt));